export default [
  {
    'x': 0,
    'y': 1,
    'w': 1,
    'h': 12,
    'i': '0',
    'component': {'title': 'Server time', 'name': 'SystemTime', 'w': 1, 'h': 8, 'needsPadding': true},
    'moved': false
  },
  {
    'x': 1,
    'y': 1,
    'w': 2,
    'h': 12,
    'i': '1',
    'component': {'title': 'Server location', 'name': 'SystemLocation', 'w': 1, 'h': 8, 'needsPadding': true},
    'moved': false
  },
  {
    'x': 3,
    'y': 1,
    'w': 1,
    'h': 12,
    'i': '2',
    'component': {'title': 'Emergency functions', 'name': 'EmergencyFunctions', 'w': 1, 'h': 9, 'needsPadding': true},
    'moved': false
  },
  {
    'x': 2,
    'y': 16,
    'w': 2,
    'h': 26,
    'i': '3',
    'component': {'title': 'Switchgroups and switch controll', 'name': 'SwitchControll', 'w': 1, 'h': 20, 'needsPadding': true},
    'moved': false},
  {
    'x': 0,
    'y': 43,
    'w': 2,
    'h': 45,
    'i': '4',
    'component': {
      'title': 'Events',
      'name': 'EventTable',
      'configName': 'EventTableConfig',
      'w': 2,
      'h': 45,
      'isConfiguring': false,
      'properties': { 'showSearch': false }},
    'moved': false
  },
  {
    'x': 2,
    'y': 43,
    'w': 2,
    'h': 45,
    'i': '5',
    'component': {
      'title': 'Event statistics',
      'name': 'EventStatistics',
      'w': 2,
      'h': 40,
      'needsPadding': true,
      'configName': 'EventStatisticsConfig',
      'isConfiguring': false
    },
    'moved': false
  },
  {
    'x': 0,
    'y': 16,
    'w': 2,
    'h': 26,
    'i': '6',
    'component': {'title': 'LAN status', 'name': 'LANStatus', 'w': 1, 'h': 20, 'needsPadding': true},
    'moved': false
  }
]



// WEBPACK FOOTER //
// ./src/components/dashboard/defaultDashboard.js